<template>
  <div class="two-step-login">
    <div class="two-step-login-p-1-top">
      <slot name="two-step-login-p-1-top"></slot>
    </div>

    <form v-if="form_step==1" @submit.prevent="onSubmitForm_1" class="mt-2">
      <h4 class="text-primary" v-t="'two_step_login.title'"></h4>

      <div class="form-group mb-4 mt-3">
        <label for="username" v-t="'authentication_general.cellphone'"></label>
        <input dir="ltr" v-model="form_step_1.cellphone" type="text"
               :placeholder="$t('authentication_general.cellphone_placeholder')"
               class="form-control rounded-pill text-left" id="username" aria-describedby="emailHelp">
        <form-errors-manager :validation="v$.form_step_1.cellphone"/>
      </div>

      <div class="">
        <m-captcha1 v-model="form_step_1.captcha_answer"/>
        <form-errors-manager :validation="v$.form_step_1.captcha_answer"/>
      </div>

      <m-modal-1 :modalButtonText="$t(`authentication_general.have_code`)" class="two-step-modal-1">
        <m-classic-login/>
      </m-modal-1>

      <button type="submit" class="btn btn-primary rounded-pill btn-block my-3 w-100"
              v-t="`two_step_login.button_submit`">
      </button>

    </form>

    <form v-if="form_step==2" @submit.prevent="onSubmitForm_2" class="mt-2">
      <h4 class="text-primary step-two-step-2-title" v-t="'two_step_login.title'"></h4>


      <div class="form-group mb-4 mt-3">
        <label for="password"> {{ $t('authentication_general.cellphone_verification_code') }} -
          {{ form_step_1.cellphone }} </label>
        <input v-model="form_step_2.code" type="text"
               :placeholder="$t('authentication_general.cellphone_verification_code')"
               class="form-control rounded-pill text-left" id="password" aria-describedby="emailHelp">
        <form-errors-manager :validation="v$.form_step_2.code"/>
      </div>


      <button type="submit" class="btn btn-primary rounded-pill btn-block my-3 w-100"
              v-t="'two_step_login.button_submit'">
      </button>
    </form>

    <form v-if="form_step == 3 || true" @submit.prevent="onSubmitForm_3" class="mt-2">
      <h4 class="text-primary" v-t="`two_step_login.title`"></h4>


      <div class="form-row">
        <div class="col">

          <div class="form-group mb-4 mt-3">
            <label for="name" v-t="'authentication_general.name'"></label>
            <input v-model="form_step_3.name" type="text" :placeholder="$t('authentication_general.name_placeholder')"
                   class="form-control rounded-pill  mt-3" id="name">
            <form-errors-manager :validation="v$.form_step_3.name"/>
          </div>

        </div>

        <div class="col">
          <div class="form-group mb-4 mt-3">
            <label for="last_name" v-t="'authentication_general.last_name'"></label>
            <input v-model="form_step_3.last_name" type="text"
                   :placeholder="$t('authentication_general.last_name_placeholder')"
                   class="form-control rounded-pill  mt-3" id="last_name">
            <form-errors-manager :validation="v$.form_step_3.last_name"/>
          </div>

        </div>

        <div class="col-12" v-if="showPanels">
          {{ sitePanels }}
          <p v-t="`authentication_general.register_panels_selection_label`"></p>
          <div class="form-check form-check-inline" v-for="panel in sitePanels">
            <input v-model="form_step_3.panels" class="form-check-input" type="radio" name="panels"
                   :id="`panel-${panel.id}`"
                   :value="panel.id">
            <label class="form-check-label mx-1" :for="`panel-${panel.id}`">{{ panel.name }}</label>
          </div>

          <form-errors-manager :validation="v$.form_step_3.panels"/>

        </div>

      </div>


      <button type="submit" class="btn btn-primary my-3 w-100 rounded-pill d-block"
              v-t="`two_step_login.button_submit`"></button>


      <div class="container">

        <i18n-t keypath="term_and_services.text" tag="label">
          <template #terms>
            <router-link class="text-decoration-none" :to="{name:'SinglePage',params:{slug:'terms'}}">
              {{ $t('term_and_services.terms') }}
            </router-link>
          </template>

          <template #privacy>
            <router-link class="text-decoration-none" :to="{name:'SinglePage',params:{slug:'privacy'}}">
              {{ $t('term_and_services.privacy') }}
            </router-link>
          </template>

          <template #site_name>
            <span>{{ findAttributeOnSiteInfo('site_name')[0] }}</span>
          </template>

        </i18n-t>

      </div>

    </form>

    <div class="two-step-login-p-1-bottom">
      <slot name="two-step-login-p-1-bottom"></slot>
    </div>

  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {useVuelidate} from '@vuelidate/core'
import {minLength, required, maxLength, integer, requiredIf} from "@vuelidate/validators";
import {phone} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/VuelidateCustomValidatoins";
import FormErrorsManager from "../../validator/FormErrorsManager";
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";
import mCaptcha1 from "../../Captcha/Captcha1";
import {captchaValidation} from "../../Captcha/CaptchaValidation";
import mModal1 from '../../Tool/Modal/Modal1.vue'
import mClassicLogin from '../../Authentication/Login/ClassicLogin.vue'

export default {
  name: "TwoStepLogin",
  components: {FormErrorsManager, mCaptcha1, mClassicLogin, mModal1},
  props: {
    redirect: {
      default: undefined
    },
    showPanels: {
      type: Boolean,
      default: false,
    },
    defaultPanel: {
      default: null,
    }
  },
  setup() {
    return {v$: useVuelidate()}
  },
  data() {
    return {
      form_step: 1,
      user_register_status: null,
      form_step_1: {
        cellphone: "",
        captcha_answer: ''
      },
      form_step_2: {
        code: "",
      },
      form_step_3: {
        name: '',
        last_name: '',
        panels: '',
      },
    };
  },
  computed: {
    ...mapGetters({
      sitePanels: "Language/getPanels"
    })
  },
  validations() {
    return {
      form_step_1: {
        cellphone: {required, phone},
        captcha_answer: captchaValidation,
      },
      form_step_2: {
        code: {required, minLength: minLength(4)},
      },
      form_step_3: {
        name: {required},
        last_name: {required},
        panels: {
          required: requiredIf(function () {
            return this.showPanels;
          }),
          integer
        },
      },
    }
  },
  methods: {
    async onSubmitForm_1() {
      const result = await this.v$.form_step_1.$validate()
      if (!result) return

      const form = this.form_step_1
      this.$store.dispatch('Authentication/loginWithSms', form).then(res => {
        this.form_step = 2
        this.user_register_status = res.data.data.userChecker
        toast('عملیات با موفقیت انجام شد', 'رمز با موفقیت برای شما ارسال شد')
      }).catch(e => {
        this.$store.dispatch('Captcha/getCaptcha')
        console.log(e)
      })

    },
    async onSubmitForm_2() {
      const result = await this.v$.form_step_2.$validate()
      if (!result) return

      const form = {
        ...this.form_step_2,
        password: this.form_step_2.code,
        cellphone: this.form_step_1.cellphone,
        email: this.form_step_1.cellphone,
        withoutRedirect: this.redirect
      }

      if (this.user_register_status) {
        form.without_captcha = true;

        this.$store.dispatch('Authentication/login', form).then(res => {

          document.querySelector('body').classList.remove('modal-open');

          document.querySelectorAll('.modal-backdrop').forEach(item => {
            item.classList.remove('modal-backdrop');
          })

          this.$emit('login', true)
        })

      } else {
        this.$store.dispatch('Authentication/loginWithSmsVerifyCellphone', form).then(res => {
          this.form_step = 3
        }).catch(error => {
          this.$store.dispatch('Captcha/getCaptcha')
          console.log(error)
        })
      }


    },
    async onSubmitForm_3() {

      const result = await this.v$.form_step_3.$validate()
      if (!result) return

      const form = {
        ...this.form_step_2,
        ...this.form_step_3,
        password: this.form_step_2.code,
        cellphone: this.form_step_1.cellphone,
        email: this.form_step_1.cellphone,
        withoutRedirect: this.redirect,

      }

      if (this.showPanels) {
        form.panels = this.form_step_3.panels
      } else {
        delete form.panels
      }


      if (this.defaultPanel != null) {
        form.panels = this.defaultPanel
      }

      console.log(form)


      this.$store.dispatch('Authentication/loginWithSmsRegister', form).then(res => {
        this.$store.dispatch('User/setUserState', res)

        this.$emit('login', true)


        document.querySelector('body').classList.remove('modal-open');

        document.querySelectorAll('.modal-backdrop').forEach(item => {
          item.classList.remove('modal-backdrop');
        })

        if (this.redirect === undefined) {
          this.$router.push({name: 'Home'})
        }

      }).catch(error => {
        this.$store.dispatch('Captcha/getCaptcha')
        console.log(error)
      })

    },
  },
}
</script>

<style scoped>
.two-step-modal-1 :deep(.modal-1-button) {
  background: transparent !important;
  border: none !important;
  color: var(--primary);
}
</style>